class QuickAdd extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();
    this.setupHover();
  }

  disconnectedCallback() {

    super.disconnectedCallback();
    window.clearTimeout(this.transitionTimer);
    window.clearTimeout(this.hoverTimer);
    window.clearTimeout(this.hoverCloseTimer);

    if (this.hoverTrigger) {
      this.hoverTrigger.removeEventListener("mouseenter", this.handleHoverEnter);
    }
    if (this.hoverPanel) {
      this.hoverPanel.removeEventListener("mouseenter", this.handlePanelEnter);
      this.hoverPanel.removeEventListener("mouseleave", this.handleHoverLeave);
    }

  }

  close() {
    if (!this.classList.contains("is-active") && !this.classList.contains("is-opening")) return;

    window.clearTimeout(this.transitionTimer);
    this.classList.remove("is-pinned", "is-hover-open", "is-opening", "is-transitioning");
    this.transitionTo(false);
  }

  toggle() {
    if (
      window.matchMedia("(max-width: 767px)").matches &&
      this.closest("product-card")
    ) {
      window.clearTimeout(this.transitionTimer);
      window.clearTimeout(this.hoverTimer);
      window.clearTimeout(this.hoverCloseTimer);
      this.classList.remove(
        "is-active",
        "is-opening",
        "is-closing",
        "is-returning",
        "is-transitioning",
        "is-hover-open",
        "is-pinned"
      );
      document.dispatchEvent(
        new CustomEvent("quickadddrawer:show", { detail: { source: this } })
      );
      return;
    }

    if (this.classList.contains("is-hover-open")) {
      this.classList.remove("is-hover-open");
      this.classList.add("is-pinned");
      return;
    }

    if (this.classList.contains("is-active")) {
      this.close();
      return;
    }

    window.clearTimeout(this.transitionTimer);
    this.classList.remove("is-closing", "is-returning", "is-transitioning");
    this.classList.add("is-pinned");
    this.transitionTo(true);
  }

  setupHover() {
    this.hoverPanel = this.querySelector("[data-product-info], .cart-upsell-item");
    this.hoverTrigger = this.querySelector(".quickadd-toggle");

    if (
      !this.hoverPanel ||
      !this.hoverTrigger ||
      window.matchMedia("(max-width: 767px)").matches ||
      !window.matchMedia("(hover: hover) and (pointer: fine)").matches
    ) {
      return;
    }

    this.handleHoverEnter = () => {
      window.clearTimeout(this.hoverCloseTimer);
      if (this.classList.contains("is-active")) return;

      this.hoverTimer = window.setTimeout(() => {
        if (this.classList.contains("is-active")) return;
        this.classList.add("is-hover-open");
        this.transitionTo(true);
      }, 200);
    };

    this.handleHoverLeave = () => {
      window.clearTimeout(this.hoverTimer);
      if (!this.classList.contains("is-hover-open")) return;

      this.classList.remove("is-hover-open");
      this.hoverCloseTimer = window.setTimeout(() => {
        if (
          this.classList.contains("is-active") &&
          !this.classList.contains("is-pinned")
        ) {
          this.transitionTo(false);
        }
      }, 260);
    };

    this.handlePanelEnter = () => {
      window.clearTimeout(this.hoverCloseTimer);
      if (
        this.classList.contains("is-active") &&
        !this.classList.contains("is-pinned")
      ) {
        this.classList.add("is-hover-open");
      }
    };

    this.hoverTrigger.addEventListener("mouseenter", this.handleHoverEnter);
    this.hoverPanel.addEventListener("mouseenter", this.handlePanelEnter);
    this.hoverPanel.addEventListener("mouseleave", this.handleHoverLeave);
  }

  transitionTo(makeActive) {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduceMotion) {
      this.classList.toggle("is-active", makeActive);
      return;
    }

    if (this.classList.contains("is-transitioning")) return;

    this.classList.add("is-transitioning");

    if (!makeActive) {
      this.classList.add("is-closing");
      this.transitionTimer = window.setTimeout(() => {
        this.classList.remove("is-active", "is-closing");
        this.classList.add("is-returning");
        this.transitionTimer = window.setTimeout(() => {
          this.classList.remove("is-transitioning", "is-returning");
        }, 150);
      }, 100);
      return;
    }

    this.classList.add("is-opening");
    this.transitionTimer = window.setTimeout(() => {
      this.classList.add("is-active");
      this.classList.remove("is-opening");
      this.transitionTimer = window.setTimeout(() => {
        this.classList.remove("is-transitioning");
      }, 150);
    }, 100);
  }

  add(_, element) {
    const container = element.closest(".spinner-container") || element;
    container.classList.add("state--loading");

    const variantId = element.dataset.variantId;
    if (!variantId) {
      container.classList.remove("state--loading");
      return;
    }

    element.classList.add("is-selected");

    const properties = { _web: "true" };
    if (element.dataset.cartGift === "true") {
      properties._cart_gift = "true";
    }
    if (element.dataset.allowCheckout === "true") {
      properties._allow_checkout = "true";
    }
    if (element.dataset.finalSale === "true") {
      properties["FINAL SALE"] = "No Returns";
    }
    if (this.closest(".cart-upsells")) {
      properties._db_upsell = "web-bag";
    }

    this.addToCart(variantId, container, properties);
  }

  addToCart(variantId, container, properties = {}) {
    const data = new FormData();
    data.set("id", variantId);

    Object.entries(properties).forEach(([key, value]) => {
      data.set(`properties[${key}]`, value);
    });

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent("addtocart", { detail: response })
        );
        this.classList.remove("is-active", "is-pinned", "is-hover-open");
        this.querySelectorAll(".quickadd-option").forEach((el) =>
          el.classList.remove("is-selected")
        );
      })
      .catch((error) => {
        console.error("QuickAdd: add to cart failed", error);
      })
      .finally(() => {
        if (container) {
          container.classList.remove("state--loading");
        }
      });
  }
}

customElements.define("quick-add", QuickAdd);

document.addEventListener("click", (event) => {
  document.querySelectorAll("quick-add.is-pinned").forEach((quickAdd) => {
    if (!quickAdd.contains(event.target)) quickAdd.close();
  });
}, true);
